{
    document.addEventListener("DOMContentLoaded", function () {
        const swiperWrapper = document.querySelector(
            ".logolist_slider .swiper-wrapper"
        );
        const slide = swiperWrapper.querySelector(".swiper-slide");

        if (slide) {
            for (let i = 0; i < 10; i++) {
                let clone = slide.cloneNode(true);
                swiperWrapper.appendChild(clone);
            }
        }

        var swiper = new Swiper(".logolist_slider", {
            slidesPerView: "auto",
            loop: true,
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
            },
            speed: 20000,
            freeMode: false,
            freeModeMomentum: false,
            breakpoints: {
                150: {
                    spaceBetween: 20,
                },
                576: {
                    spaceBetween: 30,
                },
                769: {
                    spaceBetween: 40,
                },
                1025: {
                    spaceBetween: 60,
                },
            },
        });
    });
}

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".transformationSlider").forEach((slider) => {

        const swiper = new Swiper(slider, {
            centeredSlides: false,
            spaceBetween: 30,
            speed: 1000,

            pagination: {
                el: slider.querySelector(".swiper-pagination"),
                clickable: true,
            },

            breakpoints: {
                1025: {
                    slidesPerView: 1,
                },
                769: {
                    slidesPerView: 1,
                },
                576: {
                    slidesPerView: 1,
                },
                300: {
                    slidesPerView: 1,
                },
            },

        });

    });
});

{
    document.addEventListener("DOMContentLoaded", () => {
        const MultipleSlider = () => {
            const MultipleSliders = document.querySelectorAll(".prodCardSlider");
            MultipleSliders.forEach((slider, index) => {
                const prevArrow = slider.parentElement.querySelector(".prev");
                const nextArrow = slider.parentElement.querySelector(".next");
                new Swiper(slider, {
                    effect: 'slide',
                    speed: 1000,
                    // allowTouchMove: false,
                    navigation: {
                        nextEl: nextArrow,
                        prevEl: prevArrow,
                    },
                    breakpoints: {
                        150: {
                            slidesPerView: 1.3,
                            spaceBetween: 10
                        },
                        576: {
                            slidesPerView: 2.3,
                            spaceBetween: 15
                        },
                        769: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1025: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },

                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        },
                    }
                });
            });
        };
        MultipleSlider();
    });
}

{
    document.addEventListener("DOMContentLoaded", () => {
        const MultipleSlider = () => {
            const MultipleSliders = document.querySelectorAll(".videos_sliders");
            MultipleSliders.forEach((slider, index) => {
                const prevArrow = slider.parentElement.querySelector(".prev");
                const nextArrow = slider.parentElement.querySelector(".next");
                new Swiper(slider, {
                    effect: 'slide',
                    speed: 1000,
                    // allowTouchMove: false,
                    navigation: {
                        nextEl: nextArrow,
                        prevEl: prevArrow,
                    },
                    breakpoints: {
                        150: {
                            slidesPerView: 1.5,
                            spaceBetween: 10
                        },
                        576: {
                            slidesPerView: 2.3,
                            spaceBetween: 15
                        },
                        769: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                        },
                        1025: {
                            slidesPerView: 3,
                            spaceBetween: 20
                        },

                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 30
                        },
                    }
                });
            });
        };
        MultipleSlider();
    });
}

{
    document.addEventListener("DOMContentLoaded", () => {
        const MultipleSlider = () => {
            const MultipleSliders = document.querySelectorAll(".tstm_videos_sliders");
            MultipleSliders.forEach((slider, index) => {
                const prevArrow = slider.parentElement.querySelector(".prev");
                const nextArrow = slider.parentElement.querySelector(".next");
                new Swiper(slider, {
                    effect: 'slide',
                    speed: 1000,
                    // allowTouchMove: false,
                    navigation: {
                        nextEl: nextArrow,
                        prevEl: prevArrow,
                    },
                    breakpoints: {
                        150: {
                            slidesPerView: 1.5,
                            spaceBetween: 10
                        },
                        576: {
                            slidesPerView: 2.3,
                            spaceBetween: 10
                        },
                        769: {
                            slidesPerView: 3,
                            spaceBetween: 10,
                        },
                        1025: {
                            slidesPerView: 3,
                            spaceBetween: 10
                        },

                        1200: {
                            slidesPerView: 3,
                            spaceBetween: 10
                        },
                    }
                });
            });
        };
        MultipleSlider();
    });
}

document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".logo_rows");
  if (!container) return;

  const items = Array.from(container.children);

  items.forEach((item) => {
    container.appendChild(item.cloneNode(true));
  });

  const totalWidth = container.scrollWidth / 2;

  gsap.to(container, {
    x: "-=" + totalWidth,
    duration: 30,
    ease: "none",
    repeat: -1,
    modifiers: {
      x: gsap.utils.unitize((x) => parseFloat(x) % totalWidth)
    }
  });
});


// {
//     document.addEventListener("DOMContentLoaded", function () {
//   const container = document.querySelector(".logo_rows");
//   if (!container) return;

//   const boxes = Array.from(container.querySelectorAll(".LOGO_WRP"));
//   const CLONE_COUNT = 10; 

//   for (let i = 0; i < CLONE_COUNT; i++) {
//     boxes.forEach((box) => {
//       container.appendChild(box.cloneNode(true));
//     });
//   }

//   const originalWidth = container.scrollWidth / (CLONE_COUNT + 1);
//   const SPEED = 50; 
//   const duration = originalWidth / SPEED;

//   const animation = gsap.to(container, {
//     x: -originalWidth,
//     duration: duration,
//     ease: "none", 
//     repeat: -1,
//     onReverseComplete: () => {
//       animation.totalTime(animation.rawTime() + animation.duration() * 100);
//     }
//   });

//   container.addEventListener("mouseenter", () => animation.pause());
//   container.addEventListener("mouseleave", () => animation.resume());
  
//   container.addEventListener("touchstart", () => animation.pause());
//   container.addEventListener("touchend", () => animation.resume());
// });
// }


// {
//     document.addEventListener("DOMContentLoaded", function () {
//         const container = document.querySelector(".logo_rows");
//         if (!container) return;
//         const boxes = Array.from(container.querySelectorAll(".LOGO_WRP"));
//         const CLONE_COUNT = 10;
//         for (let i = 0; i < CLONE_COUNT; i++) {
//             boxes.forEach((box) => {
//                 container.appendChild(box.cloneNode(true));
//             });
//         }
//         const scrollDistance = container.scrollWidth / 10;
//         const SPEED = 30;
//         const duration = scrollDistance / SPEED;
//         const animation = gsap.to(container, {
//             x: -scrollDistance,
//             duration: duration,
//             ease: "linear",
//             repeat: -1,
//         });
//         container.addEventListener("mouseenter", () => animation.pause());
//         container.addEventListener("mouseleave", () => animation.resume());
//     });
// }
